<!-- NAVBAR -->
<NavbarSection />

<!-- HERO SECTION -->
<HeroSection />

<!-- PROBLEM SECTION -->
<ProblemSection />

<!-- IMPACT ECOSYSTEM SECTION -->
<ImpactEcosystemSection />

<!-- SUSTAINABLE SOCIAL IMPACT NOTE -->
<SustainableSocialImpactNote />

<!-- CHOOSE YOUR LEGACY SECTION -->
<ChooseYourLegacySection />


<ImpactExchangeRateSection />

<GovernanceLockSection />

<TaxAdvantageSection />

<VSIPlatformSection />

<ChooseLegacyCTA />

<!-- FOOTER -->
<FooterSection />